import React from "react";
import {
  Button,
  Input,
  Form,
  DatePicker,
  Dropdown,
  Menu,
  Select,
  InputNumber,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import {
  SearchOutlined,
  PlusCircleOutlined,
  DownOutlined,
  PrinterOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import { TableExcel } from "../";
import { ACTIONS } from "../../utils/enums";
import dayjs from "dayjs";
import { getEnabledOptions, renderOptions } from "../../utils";
const { Option } = Select;

/* Жагсаалтын цонхны хайх хэсэг */
function Search({
  onSubmit,
  onClickNew,
  isNew,
  controls,
  loading,
  onChangeSearch,
  name,
  props,
  url,
  printRef,
  check,
}) {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const defaultSearch = JSON.parse(localStorage.getItem(`search${url}`));
  if (defaultSearch) {
    Object.keys(defaultSearch).map((key) => {
      if (key.includes("date") || key.includes("ymd")) {
        defaultSearch[key] = dayjs(defaultSearch[key]);
      }
    });
  }

  const params = useParams();
  const handleNew = () => {
    if (onClickNew) onClickNew();
    navigate(`/management/${params.id}/${params["*"]}/new`);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  const handleAction = async (e) => {
    switch (e.key) {
      case ACTIONS.EXCEL:
        return;
      case ACTIONS.PRINT:
        return handlePrint();
      default:
        return;
    }
  };

  const onFinish = (values) => {
    onSubmit && onSubmit(values);
  };

  const getSearchCols = (name) => {
    switch (name) {
      case "date":
        return (
          <Form.Item name="date" className="w-40">
            <DatePicker className="w-full" allowClear={false} />
          </Form.Item>
        );
      case "sdate":
        return (
          <Form.Item name="sdate" className="w-40">
            <DatePicker className="w-full" allowClear={false} />
          </Form.Item>
        );
      case "edate":
        return (
          <Form.Item name="edate" className="w-40">
            <DatePicker className="w-full" allowClear={false} />
          </Form.Item>
        );
      case "barcode":
        return (
          <Form.Item name="barcode" className="w-40">
            <Input className="w-full" placeholder="Кодоор хайх" allowClear />
          </Form.Item>
        );
      case "catid":
        return (
          <Form.Item name="catid" className="w-40">
            <Select
              allowClear
              placeholder="Барааны ангилал"
              showSearch
              onInputKeyDown={(e) => {
                if (e.keyCode === 13) {
                  form.submit();
                }
              }}
            >
              {renderOptions(
                getEnabledOptions(props, "salecategory"),
                "name",
                "id"
              )}
            </Select>
          </Form.Item>
        );
      case "supplier":
        return (
          <Form.Item name="supplierid" className="w-40">
            <Select
              allowClear
              placeholder="Нийлүүлэгч"
              showSearch
              onInputKeyDown={(e) => {
                if (e.keyCode === 13) {
                  form.submit();
                }
              }}
            >
              <Option value={0}>Бүгд</Option>
              {renderOptions(
                getEnabledOptions(props, "salesupplier"),
                "name",
                "id"
              )}
            </Select>
          </Form.Item>
        );
      case "name":
        return (
          <Form.Item name="name" className="w-40">
            <Input placeholder="Хайх" allowClear onChange={onChangeSearch} />
          </Form.Item>
        );
      case "buyid":
        return (
          <Form.Item name="buyid" className="w-40">
            <InputNumber
              placeholder="Баримтын дугаар"
              allowClear
              className="w-full"
            />
          </Form.Item>
        );
      case "saletype":
        return (
          <Form.Item name="saletype" className="w-40">
            <Select
              allowClear
              defaultValue={0}
              placeholder="Борлуулалтын төрөл"
              onInputKeyDown={(e) => {
                if (e.keyCode === 13) {
                  form.submit();
                }
              }}
            >
              <Option value={0}>Бүгд</Option>
              <Option value={1}>Борлуулалт</Option>
              <Option value={2}>Буцаалт</Option>
            </Select>
          </Form.Item>
        );
      case "storeid":
        if (props?._auth?.user?.type !== 2) {
          return (
            <Form.Item name="storeid" className="w-40">
              <Select
                allowClear
                placeholder="Дэлгүүр сонгох"
                showSearch
                onInputKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    form.submit();
                  }
                }}
              >
                <Option value={0}>Бүгд</Option>
                {renderOptions(props.resstore, "name", "id")}
              </Select>
            </Form.Item>
          );
        } else {
          return (
            <Form.Item name="storeid" hidden={true} className="w-40">
              <InputNumber
                className="w-full"
                defaultValue={props?._auth?.user?.storeid}
              />
            </Form.Item>
          );
        }
      case "fromid":
        if (props?._auth?.user?.type !== 2) {
          return (
            <Form.Item name="fromid" className="w-40">
              <Select
                allowClear
                placeholder="Хүлээн авсан дэлгүүр"
                showSearch
                onInputKeyDown={(e) => {
                  if (e.keyCode === 13) {
                    form.submit();
                  }
                }}
              >
                <Option value={0}>Бүгд</Option>
                {renderOptions(props.resstore, "name", "id")}
              </Select>
            </Form.Item>
          );
        } else {
          return (
            <Form.Item name="fromid" hidden={true} className="w-40">
              <InputNumber
                className="w-full"
                defaultValue={props?._auth?.user?.storeid}
              />
            </Form.Item>
          );
        }
    }
  };
  const menu = (
    <Menu onClick={handleAction}>
      <Menu.Item key={ACTIONS.EXCEL} icon={<FileExcelOutlined />}>
        <TableExcel name={name} />
      </Menu.Item>
      <Menu.Item key={ACTIONS.PRINT} icon={<PrinterOutlined />}>
        Хэвлэх
      </Menu.Item>
    </Menu>
  );
  return (
    <Form
      onFinish={onFinish}
      form={form}
      initialValues={
        defaultSearch
          ? { actions: 0, edate: dayjs(), sdate: dayjs(), ...defaultSearch }
          : {
              actions: 0,
              edate: dayjs(),
              sdate: dayjs(),
            }
      }
    >
      <div className="flex justify-between gap-2 flex-wrap">
        <div className="flex flex-wrap gap-2">
          {controls &&
            controls.split(",").map((item, i) => getSearchCols(item, i))}
          <Form.Item name="name" className="w-40">
            <Input
              placeholder="Хайх"
              allowClear
              sear
              onChange={onChangeSearch}
            />
          </Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            icon={<SearchOutlined />}
            loading={loading}
          >
            Хайх
          </Button>
          {isNew ? (
            <Button
              className="sm:block xl:hidden"
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={handleNew}
            >
              Шинэ
            </Button>
          ) : null}
          <Dropdown
            className="sm:block xl:hidden"
            overlay={menu}
            trigger={["click"]}
          >
            <Button icon={<DownOutlined />}>Үйлдлүүд</Button>
          </Dropdown>
        </div>
        <div className="xl:gap-2 sm:hidden xl:flex">
          {isNew ? (
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={handleNew}
            >
              Шинэ
            </Button>
          ) : null}

          <Dropdown overlay={menu} trigger={["click"]}>
            <Button icon={<DownOutlined />}>Үйлдлүүд</Button>
          </Dropdown>
        </div>
      </div>
    </Form>
  );
}

export default Search;
